import React from 'react';

const HeaderTop = props => (
  <div className="top-menu-1x">
    <div className="container">
      <div className="row">
        <div className="col-md-6" />
        <div className="col-md-6">
          <div className="top-menu-right">
            <div className="footer-info-right">
              <ul>
                <li>
                  <a href="https://www.facebook.com/digitalcongo.net/">
                    {' '}
                    <i className="fa fa-facebook" />{' '}
                  </a>
                </li>
                <li>
                  <a href="http://twitter.com/digitalcongo/">
                    {' '}
                    <i className="fa fa-twitter" />{' '}
                  </a>
                </li>
                <li>
                  <a href="http://youtube.com/digitalcongonet/">
                    {' '}
                    <i className="fa fa-youtube" />{' '}
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/digitalcongo/">
                    {' '}
                    <i className="fa fa-instagram" />{' '}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HeaderTop;



// WEBPACK FOOTER //
// ./src/components/HeaderTop.js